// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { displayAuthenticationError } from './basicCreators';
import { setToken } from './loginCreators';
import type { ThunkAction, User } from '../../types';

export function checkLoggedInUserIsGlobalAdmin(): ThunkAction {
  return function(dispatch, getState) {
    const { user, isLoggedIn } = getState().authentication;
    const isInternalAdminUser = user.isInternalAdminUser;

    if (isLoggedIn && !isInternalAdminUser) {
      dispatch(displayAuthenticationError());
    }
  };
}

export function getLoggedInUser(token: ?string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/user/current';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };
    if (token) {
      options.headers.token = token;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const user = response.data.user;
        dispatch({ type: 'UPDATE_LOGGED_IN_USER', user });
        return user;
      },
      error => dispatch(APIError(error, 'Error getting Logged In User'))
    );
  };
}

export function updateLoggedInUser(user: User | Object): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/user/current';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: user
    };
    return makeAPICall(endpoint, options).then(
      response => {
        if (response.data && response.data.token) {
          dispatch(setToken(response.data.token, user));
        }
        return dispatch(getLoggedInUser());
      },
      error => dispatch(APIError(error, 'Error updating Logged In User'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/authentication/userCreators.js